import { sanitizeText } from './sanitize.util';

export enum ImpressionVariable {
  EVAR24 = 'eVar24',
  EVAR72 = 'eVar72',
  EVAR73 = 'eVar73',
  EVAR87 = 'eVar87',
  EVAR110 = 'eVar110',
  EVAR130 = 'eVar130',
  EVAR131 = 'eVar131',
  EVAR132 = 'eVar132',
  EVAR133 = 'eVar133',
  EVAR134 = 'eVar134',
  EVAR148 = 'eVar148',
  EVAR149 = 'eVar149',
  EVAR153 = 'eVar153',
  EVAR161 = 'eVar161',
  EVAR105 = 'eVar105',
}

export enum ImpressionType {
  PAGE_FEATURE = 'pageFeature',
  MEMBER_SELECT = 'memberSelect',
  FIND_CARE_SEARCH_LISTING = 'find_care_search_listing',
  CLAIMS_CLICK = 'claimsClick',
  CLAIMS_IMPRESSION = 'claimsImpression',
  CTA_CLICK = 'rxcard',
  GROUP_A = 'group_a',
  GROUP_B = 'group_b',
  GROUP_C = 'group_c',
  GROUP_D = 'group_d',
  GROUP_E = 'group_e',
  GROUP_F = 'group_f',
  GROUP_G = 'group_g',
  GROUP_H = 'group_h',
  GROUP_I = 'group_i',
  GROUP_J = 'group_j',
  HW_IMPRESSIONS = 'hwimpressions',
}

export enum ImpressionEventType {
  DISPLAYED = 'displayed',
  CLICKED = 'clicked',
  PAID = 'paid',
  HW_INCENTIVE_ACCORDION = 'hw-incentives-accordion-open-goals',
}

export type ProductStringConfig =
  | EVar24Config
  | EVar72Config
  | EVar73Config
  | EVar87Config
  | EVar110Config
  | EVar130Config
  | EVar131Config
  | EVar132Config
  | EVar133Config
  | EVar134Config
  | EVar148Config
  | EVar149Config
  | EVar105Config
  | EVar153Config
  | EVar161Config;

interface EVar105Config extends ProductStringConfigBase {
  impressionType: ImpressionType.HW_IMPRESSIONS;
  impressionVariable: ImpressionVariable.EVAR105;
  slots: [string, string, string, string, string, string, string, string];
}

interface EVar110Config extends ProductStringConfigBase {
  impressionType: ImpressionType.PAGE_FEATURE;
  impressionVariable: ImpressionVariable.EVAR110;
  slots: [string, number | string, string, string, string, string];
}

interface EVar72Config extends ProductStringConfigBase {
  impressionType: ImpressionType.MEMBER_SELECT;
  impressionVariable: ImpressionVariable.EVAR72;
  slots: [string, string];
}

interface EVar73Config extends ProductStringConfigBase {
  impressionType: ImpressionType.CLAIMS_CLICK;
  impressionVariable: ImpressionVariable.EVAR73;
  slots: [string, string, string, string, string, string, string, number];
}

interface EVar130Config extends ProductStringConfigBase {
  impressionType:
    | ImpressionType.FIND_CARE_SEARCH_LISTING
    | ImpressionType.GROUP_A;
  impressionVariable: ImpressionVariable.EVAR130;
  slots: [
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
  ];
}

interface EVar131Config extends ProductStringConfigBase {
  impressionType:
    | ImpressionType.FIND_CARE_SEARCH_LISTING
    | ImpressionType.GROUP_B;
  impressionVariable: ImpressionVariable.EVAR131;
  slots: [
    number,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
  ];
}

interface EVar132Config extends ProductStringConfigBase {
  impressionType:
    | ImpressionType.FIND_CARE_SEARCH_LISTING
    | ImpressionType.GROUP_C;
  impressionVariable: ImpressionVariable.EVAR132;
  slots: [string, string, string, string, string, string, string, string];
}

interface EVar133Config extends ProductStringConfigBase {
  impressionType: ImpressionType.GROUP_D;
  impressionVariable: ImpressionVariable.EVAR133;
  slots: [
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
  ];
}

interface EVar134Config extends ProductStringConfigBase {
  impressionType: ImpressionType.GROUP_E;
  impressionVariable: ImpressionVariable.EVAR134;
  slots: [string, string, string, string, string, string, string];
}

interface EVar24Config extends ProductStringConfigBase {
  impressionType: ImpressionType.GROUP_F;
  impressionVariable: ImpressionVariable.EVAR24;
  slots: [string, string, string, string, string];
}

interface EVar148Config extends ProductStringConfigBase {
  impressionType: ImpressionType.GROUP_G;
  impressionVariable: ImpressionVariable.EVAR148;
  slots: [
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
  ];
}

interface EVar149Config extends ProductStringConfigBase {
  impressionType: ImpressionType.GROUP_H;
  impressionVariable: ImpressionVariable.EVAR149;
  slots: [
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
  ];
}

interface EVar153Config extends ProductStringConfigBase {
  impressionType: ImpressionType.GROUP_I;
  impressionVariable: ImpressionVariable.EVAR153;
  slots: [
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
  ];
}

interface EVar161Config extends ProductStringConfigBase {
  impressionType: ImpressionType.GROUP_J;
  impressionVariable: ImpressionVariable.EVAR161;
  slots: [string, string, string, string];
}

interface EVar87Config extends ProductStringConfigBase {
  impressionType: ImpressionType.CTA_CLICK;
  impressionVariable: ImpressionVariable.EVAR87;
  slots: [
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
  ];
}
interface ProductStringConfigBase {
  impressionEventType: ImpressionEventType;
  ignoreSanitize?: boolean;
}

export function formatProductString({
  impressionVariable,
  impressionType,
  impressionEventType,
  slots,
  ignoreSanitize = false,
}: ProductStringConfig) {
  return ignoreSanitize
    ? `;${impressionType};;;;${impressionVariable}=${impressionEventType}^${slots.join(
        '^',
      )}`
    : `;${impressionType};;;;${impressionVariable}=${impressionEventType}^${sanitizeSlots(
        slots,
      ).join('^')}`;
}

export function sanitizeSlots(
  slots: Array<string | number>,
): Array<string | number> {
  return slots.map((item: string | number) =>
    typeof item === 'string' ? sanitizeText(item) : item,
  );
}

export function filterSuperTag(text: string) {
  return text.replace('<sup>', '').replace('</sup>', '');
}
